var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zw zw-water-usage" }, [
    _c("div", { staticClass: "ui basic padded segment" }, [
      _c("div", { staticClass: "ui header" }, [
        _c("i", { staticClass: "icon chart line" }),
        _vm._v(
          "\n      " + _vm._s(_vm.$t("pages.water_usage.title")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ui segment zw-water-usage-filters" }, [
        _c("div", { staticClass: "ui form" }, [
          _c("div", { staticClass: "three fields zw-daterange" }, [
            _c("div", { staticClass: "field" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("pages.water_usage.filter.from")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ui input" },
                [
                  _c("flat-pickr", {
                    attrs: {
                      config: _vm.fromConfig,
                      placeholder: "YYYY-MM-DD"
                    },
                    model: {
                      value: _vm.from,
                      callback: function($$v) {
                        _vm.from = $$v
                      },
                      expression: "from"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("pages.water_usage.filter.to")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ui input" },
                [
                  _c("flat-pickr", {
                    attrs: { config: _vm.toConfig, placeholder: "YYYY-MM-DD" },
                    model: {
                      value: _vm.to,
                      callback: function($$v) {
                        _vm.to = $$v
                      },
                      expression: "to"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.kamstrupUsers.length > 1
              ? _c("div", { staticClass: "field" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("pages.water_usage.filter.house_meter"))
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedKamstrupUserId,
                          expression: "selectedKamstrupUserId"
                        }
                      ],
                      staticClass: "ui dropdown zw-meter-select",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedKamstrupUserId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            _vm.page = 1
                            _vm.fetch()
                          }
                        ]
                      }
                    },
                    _vm._l(_vm.kamstrupUsers, function(item) {
                      return _c(
                        "option",
                        { key: item.id, domProps: { value: item.id } },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(item.username) +
                              "\n                - " +
                              _vm._s(item.address || "-") +
                              ", " +
                              _vm._s(item.city || "-") +
                              "\n                - " +
                              _vm._s(item.user_number || "-") +
                              "\n                " +
                              _vm._s(
                                item.meter_number
                                  ? " (" + item.meter_number + ")"
                                  : ""
                              ) +
                              "\n                " +
                              _vm._s(
                                item.is_current_unpaid ? " - Aktuel" : ""
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.meta
        ? _c("div", { staticClass: "ui labels zw-water-usage-labels" }, [
            _vm.selectedKamstrupUser
              ? _c("div", { staticClass: "ui label" }, [
                  _c("i", { staticClass: "home icon" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.selectedHouseText) + "\n      "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ui label" }, [
              _c("i", { staticClass: "barcode icon" }),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("pages.water_usage.meter_serial_number")) +
                  "\n        "
              ),
              _c("div", { staticClass: "detail" }, [
                _vm._v("\n          " + _vm._s(_vm.meterSerial) + "\n        ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui label" }, [
              _c("i", { staticClass: "calendar icon" }),
              _vm._v("\n        " + _vm._s(_vm.rangeText) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", { staticClass: "ui celled table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("pages.water_usage.table.date")))]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm.$t("pages.water_usage.table.start_meter")))
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm.$t("pages.water_usage.table.end_meter")))
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "right aligned" }, [
              _vm._v(_vm._s(_vm.$t("pages.water_usage.table.total")))
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(_vm._s(_vm.$t("pages.water_usage.table.info_codes")))
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.rows, function(row) {
            return _c("tr", { key: row.day }, [
              _c("td", [
                _c(
                  "button",
                  {
                    staticClass: "zw-day-link",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.openHourlyModal(row.day)
                      }
                    }
                  },
                  [_vm._v("\n            " + _vm._s(row.day) + "\n          ")]
                )
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(row.start_volume))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(row.end_volume))]),
              _vm._v(" "),
              _c("td", { staticClass: "right aligned" }, [
                _vm._v(_vm._s(row.used_volume))
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(row.info_codes || "-"))])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "zw-paginate" }, [
        _c(
          "div",
          { staticClass: "ui pagination menu" },
          [
            _c(
              "a",
              {
                staticClass: "item",
                class: { disabled: _vm.page === 1 },
                on: {
                  click: function($event) {
                    return _vm.go(_vm.page - 1)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("pages.water_usage.table.pagination.prev")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.totalPages, function(p) {
              return _c(
                "a",
                {
                  key: p,
                  staticClass: "item",
                  class: { active: p === _vm.page },
                  on: {
                    click: function($event) {
                      return _vm.go(p)
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(p) + "\n        ")]
              )
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "item",
                class: { disabled: _vm.page === _vm.totalPages },
                on: {
                  click: function($event) {
                    return _vm.go(_vm.page + 1)
                  }
                }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("pages.water_usage.table.pagination.next")) +
                    "\n        "
                )
              ]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.hourlyModal.open
        ? _c(
            "div",
            {
              staticClass: "zw-water-usage-modal-backdrop",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  return _vm.closeHourlyModal.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "zw-water-usage-modal ui segment" }, [
                _c("div", { staticClass: "zw-water-usage-modal-header" }, [
                  _c("h4", { staticClass: "ui header" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("pages.water_usage.hourly.title")) +
                        " - " +
                        _vm._s(_vm.hourlyModal.day) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ui icon button",
                      attrs: { type: "button" },
                      on: { click: _vm.closeHourlyModal }
                    },
                    [_c("i", { staticClass: "close icon" })]
                  )
                ]),
                _vm._v(" "),
                _vm.hourlySelectedKamstrupUser
                  ? _c("div", { staticClass: "ui labels" }, [
                      _c("div", { staticClass: "ui label" }, [
                        _c("i", { staticClass: "home icon" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.hourlySelectedHouseText) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "ui label" }, [
                        _c("i", { staticClass: "barcode icon" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("pages.water_usage.meter_serial_number")
                            ) +
                            "\n            "
                        ),
                        _c("div", { staticClass: "detail" }, [
                          _vm._v(_vm._s(_vm.hourlyMeterSerial))
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.hourlyModal.loading
                  ? _c("div", { staticClass: "ui active inline loader" })
                  : _c("table", { staticClass: "ui celled table" }, [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("pages.water_usage.table.date"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "right aligned" }, [
                            _vm._v(
                              _vm._s(_vm.$t("pages.water_usage.table.total"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pages.water_usage.table.info_codes")
                              )
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          !_vm.hourlyModal.rows.length
                            ? _c("tr", [
                                _c("td", { attrs: { colspan: "3" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("pages.water_usage.hourly.no_data")
                                    )
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.hourlyModal.rows, function(row) {
                            return _c("tr", { key: row.datetime }, [
                              _c("td", [_vm._v(_vm._s(row.datetime))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "right aligned" }, [
                                _vm._v(_vm._s(row.used_volume))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(row.info_codes || "-"))])
                            ])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.hourlyModal.rows.length
                        ? _c("tfoot", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass: "right aligned",
                                  attrs: { colspan: "2" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pages.water_usage.hourly.total_per_day"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("th", { staticClass: "right aligned" }, [
                                _vm._v(
                                  _vm._s(_vm.formatVolume(_vm.hourlyTotalUsed))
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b236c42", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b236c42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/kamstrup/WaterUsageStats.vue
// module id = /V56
// module chunks = 1